import styled from 'styled-components';
import { Formik } from 'formik';
import { AppInput } from '@/layout/AppComponents';
import Translator from '@/layout/components/helpers/Translator';
import AppLink from '@/routing/helpers/AppLink';
import wlv2 from '@/assets/images/wlv2.png';

export default function AuthClientAecq({ validationSchema, errorMsg, onHandleLogin }) {
  return (
    <Container>
        <div className="aecq-container">
            <div className="aecq-header">
                <img className="aecq-headerLogo" src="/images/client/aecq/logo.png" />
                <img className="wl-headerLogo" src={wlv2} />
            </div>
            <div className="aecq-loginContainer">
                <h3 className="aecq-title">Plataforma de revalorización de productos químicos</h3>
                <Formik
                    initialValues={{
                        username: '',
                        password: '',
                    }}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={validationSchema}
                    onSubmit={onHandleLogin}
                    >
                    {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
                        <form onSubmit={handleSubmit}>
                            <label><b>Usuario</b></label>
                            <AppInput
                                name="username"
                                value={values.username}
                                error={errors.username}
                                onChange={(v) => setFieldValue('username', v)}
                                className="aecq-input"
                            />
                            <label><b>Contraseña</b></label>
                            <AppInput
                                name="password"
                                value={values.password}
                                error={errors.password}
                                onChange={(v) => setFieldValue('password', v)}
                                className="aecq-input"
                                isPassword
                            />
                            <button
                                type="submit"
                                className="aecq-button"
                                disabled={isSubmitting}
                            >
                                Acceder
                            </button>
                        </form>
                    )}
                </Formik>
                <div className="aecq-remember-container">
                    <AppLink path="user_remember_password" className="aecq-remember">
                        He olvidado mi contraseña
                    </AppLink>
                </div>
                {errorMsg && <div className="aecq-error"><Translator file="user" name="user.login.error" /></div>}
            </div>
        </div>
    </Container>
  );
}

const Container = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    .aecq-container{
        height: 100%;
        flex: 1;
        background: #005b90;
    }
    .aecq-header{
        width: 100%;
        background: white;
        height: 30%;
        border-bottom-left-radius: 100px;
        padding: 40px 0;
        text-align: center;
    }
    .aecq-headerLogo{
        margin: 0 50px;
    }
    .wl-headerLogo{
        width: 200px;
        margin: 0 50px;
    }
    .aecq-loginContainer{
        margin: 50px auto 0 auto;
        width: 80%;
        max-width: 350px;
    }
    .aecq-loginContainer .aecq-title{
        color: white;
        margin-bottom: 36px;
        font-size: 24px;
        text-align: center;
    }
    .aecq-loginContainer label{
        display: block;
        text-align: left;
        text-transform: uppercase;
        color: white;
    }
    .aecq-loginContainer .terms{
        display: block;
        text-align: left;
        text-transform: none;
        color: white;
    }
    .aecq-loginContainer .terms a{
        color: white;
        font-weight: bold;
        text-decoration: underline;
    }
    .aecq-loginContainer .aecq-input{
        width: 100%;
        border-radius: 2px;
        border: 0;
        height: 40px;
        background: white;
        border-bottom: grey;
        border-bottom-width: 1px;
        margin-bottom: 10px;
        padding: 0 10px;
    }
    .aecq-button{
        background: rgba(13,47,67,1);
        width: 100%;
        height: 40px;
        border: 0;
        color: white;
        text-transform: uppercase;
        margin-top: 20px;
    }
    .aecq-error{
        color: white;
        text-align: center;
        margin-top: 10px;
    }
    .aecq-remember-container{
        text-align: right;
        padding: 10px 0;
    }
    .aecq-remember{
        color:white;
    }
    .aecq-remember:hover, .aecq-remember:active, .aecq-remember:focus {
        color:lightgrey;
        text-decoration: none;
    }
`;
